import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { TimeOutService } from './service/time-out.service';
import { ParamContext } from '../service/param.context';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {

    constructor(protected timeOutService: TimeOutService,
                protected context: ParamContext) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const config = this.timeOutService.getTimeOutConfig();

        if (this.shouldApplyTimeout(request)) {
            let timeoutValue = config.defaultTimeoutValue;

            // Set different timeout values for different request methods
            if (request.method === 'POST') {
                // Longer timeout for POST requests
                timeoutValue = config.postTimeOutValue;
            }

            if (request.headers.has('TIMEOUT')) {
                // use timeout specified if available
                timeoutValue = parseInt(request.headers.get('TIMEOUT'), 10);
            }

            return next.handle(request).pipe(
                timeout(timeoutValue),
                catchError((error: any) => {
                    if (error instanceof Error && error.message && error.message.includes('Timeout')) {
                        const timeoutError = new HttpErrorResponse({
                            error: {
                                errors: ['Request timed out. Server did not respond within the expected time.']
                            },
                            headers: request.headers,
                            status: 408, // Request Timeout status
                            statusText: 'Request Timeout',
                            url: request.url
                        });
                        return throwError(timeoutError);
                    }
                    return throwError(error);
                })
            );
        }
        return next.handle(request);
    }

    private shouldApplyTimeout(request: HttpRequest<any>): boolean {
        if (request.headers.has('apply-timeout')) {
            return request.headers.get('apply-timeout') === 'true';
        }
        return false;
    }

}
